import { apiClient } from "@/http";
import { apiRoutes } from "./apiRoutes";

// Dataset(primary anchor source)의 canonical 채널 디렉터리와 extra 파일 폴더를 하나로 합친
// 디렉터리 트리다. backend api/v1/dataset/extra_files 의 `/directory-tree` 가 반환한다.
// 서버는 노드마다 canonical(채널 데이터) 파일 수와 extra(주입 가능) 파일 수를 따로 준다.
// 응답에 파일은 없다. 응답 크기는 폴더 수에 비례한다.
// 폴더를 펼칠 때의 파일 목록은 따로 조회한다(canonical=episodes, extra=extra-files?parent=).

// 폴더 트리 노드(재귀)다. backend DirectoryFolderResp 와 1:1 이다. *_file_count 는 이 폴더와
// 모든 하위 폴더의 합이다(재귀). folders 는 직속 하위 폴더다(이름순).
export type DirectoryFolder = {
  name: string;
  path: string;
  canonical_file_count: number;
  extra_file_count: number;
  // 이 경로의 canonical 디렉터리 의미 분류다(hatchery-data DirectoryNamespace 의 값).
  // 이 값이 있으므로 폴더 종류를 경로 문자열로 추측하지 않는다.
  // canonical 디렉터리가 없는 노드는 null 이다(extra 전용 폴더, 하위 폴더 때문에 생긴 중간 조상).
  // 조상은 하위의 분류를 물려받지 않는다.
  namespace: string | null;
  // namespace 안의 sub-channel(카메라 이름 등). 없으면 null.
  channel: string | null;
  folders: DirectoryFolder[];
};

// 디렉터리 트리다. backend DirectoryTreeResp 와 1:1 이다. folders 는 루트 직속 하위 트리다.
// root_*_file_count 는 루트 직속 파일 수다.
export type DirectoryTree = {
  // 이 데이터셋을 다운로드할 때 만들 루트 폴더 이름이다. 표시명에서 폴더 이름에 쓸 수 없는
  // 문자를 바꾼 값이다. **변환 규칙은 서버가 소유한다.** FE 는 표시명에서 이 값을 다시 만들지
  // 않는다. 두 언어가 규칙을 따로 가지면, 미리보기의 경로와 실제 저장 경로가 달라진다.
  download_folder_name: string;
  // 변환 전 원문이다. 위 값과 다르면 이름이 바뀐 것이다. 다운로드 전에 그 사실을 알린다.
  dataset_display_name: string;
  folders: DirectoryFolder[];
  root_canonical_file_count: number;
  root_extra_file_count: number;
};

// canonical 과 extra 를 병합한 디렉터리 트리를 조회한다.
// 404 dataset.not_found 는 dataset 이 없거나 visibility 조건을 충족하지 않는다는 뜻이다.
export async function getDatasetDirectoryTree(datasetUuid: string): Promise<DirectoryTree> {
  const response = await apiClient.get<DirectoryTree>(apiRoutes.dataset.directoryTree(datasetUuid));
  return response.data;
}
